import { Reveal, Overline } from "@/components/Reveal";
import { useQuery } from "@tanstack/react-query";
import { api, INSTAGRAM } from "@/lib/api";
import { Star, Instagram } from "lucide-react";

export default function Reviews() {
  const { data: reviews = [] } = useQuery({
    queryKey: ["reviews"],
    queryFn: async () => (await api.get("/reviews")).data,
  });

  return (
    <section
      id="reviews"
      className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 md:py-32"
      data-testid="reviews"
    >
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Reveal>
            <Overline>The Love We&apos;ve Received</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 max-w-2xl font-serif text-4xl font-light leading-tight md:text-6xl">
              Loved across{" "}
              <span className="gold-gradient-text italic">Pune</span> &amp;
              beyond.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <a
            href={INSTAGRAM}
            target="_blank"
            rel="noreferrer"
            data-testid="reviews-instagram"
            className="flex items-center gap-2 text-sm text-[#A894C2] transition-colors hover:text-gold"
          >
            <Instagram size={18} /> @elixz.chocolates
          </a>
        </Reveal>
      </div>

      <div className="mt-14 columns-1 gap-6 md:columns-2 lg:columns-3">
        {reviews.map((r, i) => (
          <Reveal
            key={r.id}
            delay={(i % 3) * 0.1}
            className="mb-6 flex break-inside-avoid flex-col rounded-2xl border border-[#311B4D] bg-[#140823] p-8 transition-colors duration-500 hover:border-[#D4AF37]/40"
            data-testid={`review-card-${i}`}
          >
            <div className="flex gap-1 text-gold">
              {Array.from({ length: r.rating }).map((_, k) => (
                <Star key={k} size={15} fill="#D4AF37" strokeWidth={0} />
              ))}
            </div>
            <p className="mt-5 flex-1 font-serif text-lg font-light italic leading-relaxed text-[#FDFBF7]">
              &ldquo;{r.text}&rdquo;
            </p>
            <div className="mt-6">
              <div className="text-sm font-semibold text-[#FDFBF7]">
                {r.name}
              </div>
              <div className="text-xs text-[#A894C2]">{r.role}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
